<section class="w-100 float-left client_section">
    <div class="container">
        <div class="main_title d-flex justify-content-center">
            <h1 class="line"><span>Our Valuable</span> Clients </h1>
        </div>
        <h2 class="sub_title text-center w-100 float-left">We are pleased to serve one of the most reputed and respected brands across different sectors globally</h2>
        <div class="w-100 float-left mt-4">
            <section class="customer-logos slider" *ngIf="clients">
                <div class="slide client_logo" *ngFor="let image of clients">
                    <img [src]="image.feature_image" alt="Clients">
                </div>
                <div class="slide client_logo" *ngFor="let image of clients">
                    <img [src]="image.feature_image" alt="Clients">
                </div>
            </section>
            <div class="main-content w-100 float-left text-center mt-5"
               >
                <div class="item button-jittery">
                    <button class="main_btn" routerLink="/contact-us">Let us WOW you</button>
                </div>
            </div>
        </div>
    </div>
</section>